import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  StatusFormatter,
  columnsComplate,
  columnsUploadRci,
  components,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  selectStyles,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  showVehicleDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
  useStylesSelect,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  addUploadFileRCI,
  editInbound,
  editVehicle,
  editVehicleComplate,
  editVehicleConfrim,
  editVehicleRCI,
  fetchFileTemplate,
  fetchFileTemplateBlob,
  fetchIdInbound,
  fetchIdVehicleFind,
  fetchInbound,
  fetchVehicle,
  fetchVehicleInboundWorkflow,
  removeVehicle,
  removeVehicleWorkFlow,
  selectIdInbound,
  selectInspection,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
} from "./inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InputNumber from "../../utility/InputNumber";
import { env } from "../../../env";
import {
  prosesUpload,
  prosesUploadCancel,
} from "../miscellaneous/MiscellaneousSlice";
import { VehicleUnplaneCreate } from "./VehicleUnplaneCreate";
import { ModalPrintLabel } from "./ModalPrintLabel";
import { parse } from "date-fns";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const RCIPage = ({
  active,
  paramFilter,
  setParamFilter,
  paramValue,
  setParamValue,
  value,
  setValue,
  formValues,
  setFormValues,
  show,
  setShow,
  showScan,
  setShowScan,
  showDetailDamage,
  setShowDetailDamage,
  create,
  setCreate,
  columnsInspection,
  setColumnsInspection,
  listInspection,
  setListInspection,
  detailDamage,
  setDetailDamage,
  rowInspection,
  setRowInspection,
  rowIndexInspection,
  setRowIndexInspection,
  showVehicle,
  setShowVehicle,
  formVehicle,
  setFormVehicle,
  getData,
  setGetData,
  showPrint,
  setShowPrint,
  getDataPrint,
  setGetDataPrint,
  labelTemplate,
  setLabeltemplate,
  vehiclePrint,
  setVehiclePrint,
  dataViewer,
  setDataViewer,
  copy,
  setCopy,
  getDataProduct,
  setGetDataProduct,
  getDataModel,
  setGetDataModel,
  getDataColor,
  setGetDataColor,
  optionsList,
  setOptionsList,
  pagePrint,
  setPagePrint,
}) => {
  const classes = useStyles();
  const classesSelect = useStylesSelect();

  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdInbound);
  const data = useSelector(selectVehicle);
  const dataInspetion = useSelector(selectInspection);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [status, setStatus] = useState("");
  const [force, setForce] = useState(false);
  const inputRef = useRef(null);

  const [tableData, setTableData] = useState([]);

  const [row, setRow] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [formatExtraData, setFormatExtraData] = useState([]);
  const [listInspectionCreate, setListInspectionCreate] = useState([]);

  const [vin, setVin] = useState("");
  const [von, setVon] = useState("");
  const [engineNo, setEngineNo] = useState("");
  const [mileage, setMileage] = useState("");
  const [keyNumber, setKeyNumber] = useState("");
  const [inspectoinResult, setInspectoinResult] = useState("OK");
  const [remarks, setRemark] = useState("");
  const [inbounRule, setInbounRule] = useState("N");

  const [scanFrom, setScanFrom] = useState("");

  // useEffect(() => {
  //   // Reset on first load
  //   if (active === 0) {
  //     setForce(true);
  //   }
  // }, [active]);

  useEffect(() => {
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
        // list: list,
        // vehicle_status: "2020",
      };
    });

    setTableData(initData);
  }, [data]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setForce(false);
    }
  }, [force]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setParamFilter("");
    } else {
      setParamFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let result;
    let params = {};

    if (value === 0) {
      result = "1020,1040,2010,2011,2020";
    } else if (value === 1) {
      result = "1020,1040,2010,2011,2020";
      params.is_planned = "N";
    } else if (value === 2) {
      result = "2030";
      params.is_planned = "Y,N";
    }
    console.log(result, "result");

    params[paramFilter] = paramValue;
    params.vehicle_status = result;
    params.inbound_id = id;
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleInboundWorkflow(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let result;
      let params = {};

      if (value === 0) {
        result = "1020,1040,2010,2011,2020";
      } else if (value === 1) {
        result = "1020,1040,2010,2011,2020";
        params.is_planned = "N";
      } else if (value === 2) {
        result = "2030";
        params.is_planned = "Y,N";
      }
      params[paramFilter] = paramValue;
      params.vehicle_status = result;
      params.inbound_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;

      try {
        const response = await dispatch(fetchVehicleInboundWorkflow(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableData(result);
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const actionFormatterInspection = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={() => {
                const initData = row.detail.map((item, index) => {
                  return {
                    ...item,
                    no: index + 1,
                  };
                });

                setDetailDamage(initData);

                setRowInspection(row);
                setRowIndexInspection(rowIndex);

                setShowDetailDamage(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      </>
    );
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {row.vehicle_status !== "1040" && (
            <>
              {/* {dataId.rci_status !== "CONFIRMED" && (
             
              )} */}

              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
              >
                <div
                  className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                  onClick={() => {
                    const initData = row.listInspection.map((item, index) => {
                      return {
                        ...item,
                        no: index + 1,
                      };
                    });

                    const result = row.listColumn.map((item) => {
                      return {
                        text: item,
                        dataField: item,
                        // editable: false,
                      };
                    });

                    const finalResult = [
                      {
                        text: "Category",
                        dataField: "category_name",
                      },
                      {
                        text: "Inspection Point",
                        dataField: "name",
                      },
                      ...result,
                      {
                        dataField: "actions",
                        text: "Actions",
                        formatter: actionFormatterInspection,
                      },
                    ];
                    setRow(row);
                    setRowIndex(rowIndex);
                    setListInspection(initData);
                    setColumnsInspection(finalResult);
                    setFormValues({
                      ...formValues,
                      vehicle_id: {
                        value: row.vehicle_id,
                        error: false,
                        required: "N",
                      },
                      vin: {
                        value: row.vin,
                        error: false,
                        required: "Y",
                      },
                      von: {
                        value: row.von,
                        error: false,
                        required: "N",
                      },
                      mileage: {
                        value: row.mileage,
                        error: false,
                        required: "N",
                      },
                      engine_no: {
                        value: row.engine_no,
                        error: false,
                        required: "N",
                      },
                      key_no: {
                        value: row.key_no,
                        error: false,
                        required: "N",
                      },
                      rci_date: {
                        value: row.rci_date,
                        error: false,
                        required: "Y",
                      },
                      inspection_result: {
                        value: row.rci_results,
                        error: false,
                        required: "Y",
                      },
                      remarks: {
                        value: row.remark_rci,
                        error: false,
                        required: "N",
                      },
                      inbound_rule: {
                        value: row.inbound_rule,
                        error: false,
                        required: "N",
                      },

                      validasi_action: {
                        value:
                          parseInt(row.vehicle_status) === 2020 ||
                          parseInt(row.vehicle_status) === 2030 ||
                          parseInt(row.vehicle_status) > 3000
                            ? "Y"
                            : "N",
                        error: false,
                        required: "N",
                      },
                    });

                    setCreate(false);
                    setShow(true);
                  }}
                >
                  <span className="svg-icon svg-icon-md svg-icon-light">
                    {parseInt(row.vehicle_status) === 2020 ||
                    parseInt(row.vehicle_status) === 2030 ||
                    parseInt(row.vehicle_status) > 3000 ? (
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")}
                      />
                    ) : (
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")}
                      />
                    )}
                  </span>
                </div>
              </OverlayTrigger>
            </>
          )}

          {row.vehicle_status !== "1040" && row.vehicle_status !== "2020" && (
            <>
              {dataId.rci_status !== "CONFIRMED" && (
                <>
                  {value !== 2 && (
                    <OverlayTrigger
                      overlay={
                        <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                      }
                    >
                      <div
                        className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                        onClick={(e) => handleDelete(e, row)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-light">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/New/delete.svg"
                            )}
                          />
                        </span>
                      </div>
                    </OverlayTrigger>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Require Acc. Installation",
      dataField: "inbound_rule",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Inspection Result",
      dataField: "rci_results",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },

    {
      text: "Inspection Remarks",
      dataField: "remark_rci",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Engine No.",
      dataField: "engine_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Key No.",
      dataField: "key_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Mileage",
      dataField: "mileage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "From Location",
      dataField: "from_location_rci",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "To Location",
      dataField: "to_location_rci",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "RCI Date",
      dataField: "rci_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
      formatter : formatDate
    },
    {
      text: "User",
      dataField: "rci_updatedby",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (parseFloat(row.value) > parseFloat(row.max_weight)) {
      row.value = row.max_weight;
      forceUpdate();
      return true;
    } else if (parseFloat(row.value) < 0) {
      row.value = 0;
      forceUpdate();
      return true;
    }
  };

  const inputValue = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        step="any"
        className="input-box-table"
        value={parseFloat(row.value)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  const columnsDetailDamage = [
    {
      text: "Name",
      dataField: "name",
      editable: false,
    },

    {
      text: "Value",
      dataField: "value",
      formatter: inputValue,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
    },
  ];

  const handleClose = () => {
    setFormValues({
      ...formValues,
      vehicle_id: {
        value: "",
        error: false,
        required: "Y",
      },
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      von: {
        value: "",
        error: false,
        required: "N",
      },

      mileage: {
        value: "",
        error: false,
        required: "N",
      },
      engine_no: {
        value: "",
        error: false,
        required: "N",
      },
      key_no: {
        value: "",
        error: false,
        required: "N",
      },
      rci_date: {
        value: "",
        error: false,
        required: "Y",
      },
      inspection_result: {
        value: "",
        error: false,
        required: "Y",
      },
      remarks: {
        value: "",
        error: false,
        required: "N",
      },
      inbound_rule: {
        value: "N",
        error: false,
        required: "N",
      },
      validasi_action: {
        value: "N",
        error: false,
        required: "N",
      },
    });

    setShow(false);
    setRow(null);
  };

  const handleCloseScan = () => {
    setScanFrom("");
    setShowScan(false);
  };

  const handleCloseDetailDamage = () => {
    setShowDetailDamage(false);
  };
  console.log(rowIndexInspection, "rowIndexInspect");

  const handleSaveDetailDamage = () => {
    console.log(rowIndexInspection, "rowIndexInspection asd");
    const result = {
      ...rowInspection,
      detail: [...rowInspection.detail],
    };

    const _detailDamage = [...detailDamage];
    console.log(rowInspection, "rowInspection asd");

    _detailDamage.forEach((item) => {
      result[item.name] = item.value;
      const detailIndex = result.detail.findIndex(
        (detail) => detail.name === item.name
      );

      if (detailIndex !== -1) {
        console.log("if");
        const detailItem = { ...result.detail[detailIndex] };
        detailItem.value = item.value;
        result.detail[detailIndex] = detailItem;
      } else {
        console.log("else");

        result.detail.push(item);
      }
    });

    console.log(result, "result");

    const updatedListInspection = [...listInspection];
    updatedListInspection[rowIndexInspection] = result;

    const updatedRow = {
      ...row,
      listInspection: updatedListInspection,
    };

    setListInspection(updatedListInspection);
    setRow(updatedRow);
    setShowDetailDamage(false);
  };

  const handleSave = async (status) => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    const vehicleInspects = listInspection.reduce((result, item) => {
      item.detail.forEach((detailItem) => {
        result.push({
          name: detailItem.name,
          damagecondition_id: detailItem.damagecondition_id,
          max_weight: detailItem.max_weight,
          value: detailItem.value,
          pref_damagecondition_id: detailItem.pref_damagecondition_id,
          pref_inspectionpoint_id: item.pref_inspectionpoint_id,
          preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
          status: 2011,
          remarks_perpoint: item.remarks_perpoint,
        });
      });
      return result;
    }, []);

    let params;

    if (create === true) {
      params = {
        inbound_id: id,
        vin: formValues.vin.value,
        von: formValues.von.value,
        engine_no: formValues.engine_no.value,
        mileage: formValues.mileage.value,
        key_no: formValues.key_no.value,
        manual_action_date: formValues.rci_date.value,
        inspection_result: formValues.inspection_result.value,
        remarks: formValues.remarks.value,
        inbound_rule: formValues.inbound_rule.value,
        vehicle_id: formValues.vehicle_id.value,
        preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
        vehicleInspects:
          formValues.inspection_result.value === "OK" ? null : vehicleInspects,
        vehicle_status:
          formValues.inspection_result.value === "OK" ? "2010" : "2011",
      };
    } else {
      const code =
        formValues.inspection_result.value === "OK" ? "2010" : "2011";
      const statusCode = code === row.vehicle_status ? null : code;

      console.log(statusCode, "statusCode");

      params = {
        inbound_id: id,
        vin: formValues.vin.value,
        von: formValues.von.value,
        engine_no: formValues.engine_no.value,
        mileage: formValues.mileage.value,
        key_no: formValues.key_no.value,
        manual_action_date: formValues.rci_date.value,
        inspection_result: formValues.inspection_result.value,
        remarks: formValues.remarks.value,
        inbound_rule: formValues.inbound_rule.value,
        vehicle_id: formValues.vehicle_id.value,
        preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
        vehicleInspects:
          formValues.inspection_result.value === "OK" ? null : vehicleInspects,
        vehicle_status: code,
      };
    }

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleRCI(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleClose();
        await dispatch(fetchIdInbound(id));

        await handleSearch();
      } else {
        await handleClose();
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      await handleClose();
      showErrorDialog(error.message);
    }
  };

  const handleSaveConfrim = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    const params = {
      inbound_id: id,
      vin: formValues.vin.value,
      von: formValues.von.value,
      engine_no: formValues.engine_no.value,
      mileage: formValues.mileage.value,
      key_no: formValues.key_no.value,
      manual_action_date: formValues.rci_date.value,
      inspection_result: formValues.inspection_result.value,
      remarks: formValues.remarks.value,
      inbound_rule: formValues.inbound_rule.value,
      vehicle_id: formValues.vehicle_id.value,
      preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
      vehicleInspects: null,
      vehicle_status: "2010",
    };
    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleRCI(params));
      if (response.payload.status === 200) {
        const responseConfirm = await dispatch(
          editVehicleRCI({
            ...params,
            vehicle_status: "2030",
          })
        );

        if (responseConfirm.payload.status === 200) {
          const action = await showSuccessDialog(
            responseConfirm.payload.data.message
          );

          await handleClose();
          await dispatch(fetchIdInbound(id));
          await handleSearch();
        } else {
          await handleClose();
          showErrorDialog(responseConfirm.payload.data.message);
        }
      } else {
        await handleClose();

        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      await handleClose();

      console.log(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const handleModalCreate = () => {
    const initData =
      dataInspetion !== null
        ? dataInspetion.listInspection.map((item, index) => {
            return {
              ...item,
              no: index + 1,
              status: 2011,
            };
          })
        : [];

    const result =
      dataInspetion !== null
        ? dataInspetion.listColumn.map((item) => {
            return {
              text: item,
              dataField: item,
              // editable: false,
            };
          })
        : [];

    const finalResult = [
      {
        text: "Category",
        dataField: "category_name",
      },
      {
        text: "Inspection Point",
        dataField: "name",
      },
      ...result,
      {
        dataField: "actions",
        text: "Actions",
        formatter: actionFormatterInspection,
      },
    ];
    setListInspection(initData);
    setColumnsInspection(finalResult);
    setCreate(true);
    setShow(true);
  };

  const handleConfirm = async () => {
    const params = {
      inbound_id: id,
      vehicle_status: "2030",
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleConfrim(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleComplate = async () => {
    const params = {
      inbound_id: id,
      // vehicle_status: "2030",
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleComplate(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDelete = async (e, row) => {
    const params = [
      {
        vehicle_id: `${row.vehicle_id}`,
        document_id: id,
      },
    ];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeVehicleWorkFlow({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleInspectionResultChange = (e) => {
    setFormValues({
      ...formValues,
      ["inspection_result"]: {
        ...formValues["inspection_result"],
        value: e.target.value,
      },
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleModalEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleFind = async () => {
    if (scanFrom === "") {
      return showDialog("Please scan or enter code");
    }
    const params = `${scanFrom}?document_id=${id}`;
    try {
      const response = await dispatch(fetchIdVehicleFind(params));

      if (response.payload.status === 200) {
        const dataId = response.payload.data.data;
        setFormValues({
          ...formValues,
          vehicle_id: {
            value: dataId.vehicle_id,
            error: false,
            required: "N",
          },
          vin: {
            value: dataId.vin,
            error: false,
            required: "Y",
          },
          von: {
            value: dataId.von,
            error: false,
            required: "N",
          },
          mileage: {
            value: dataId.mileage,
            error: false,
            required: "N",
          },
          engine_no: {
            value: dataId.engine_no,
            error: false,
            required: "N",
          },
          key_no: {
            value: dataId.key_no,
            error: false,
            required: "N",
          },
          rci_date: {
            value: dataId.rci_date,
            error: false,
            required: "Y",
          },
          inspection_result: {
            value: dataId.rci_results === null ? "" : dataId.rci_results,
            error: false,
            required: "Y",
          },
          remarks: {
            value: dataId.remark_rci,
            error: false,
            required: "N",
          },
          inbound_rule: {
            value: dataId.inbound_rule,
            error: false,
            required: "N",
          },
          validasi_action: {
            value:
              parseInt(dataId.vehicle_status) === 2020 ||
              parseInt(dataId.vehicle_status) === 2030 ||
              parseInt(dataId.vehicle_status > 3000)
                ? "Y"
                : "N",
            error: false,
            required: "N",
          },
        });

        const initData =
          dataId.listInspection === null
            ? []
            : dataId.listInspection.map((item, index) => {
                return {
                  ...item,
                  no: index + 1,
                };
              });

        const result =
          dataId.listColumn === null
            ? []
            : dataId.listColumn.map((item) => {
                return {
                  text: item,
                  dataField: item,
                  // editable: false,
                };
              });

        const finalResult = [
          {
            text: "Category",
            dataField: "category_name",
          },
          {
            text: "Inspection Point",
            dataField: "name",
          },
          ...result,
          {
            dataField: "actions",
            text: "Actions",
            formatter: actionFormatterInspection,
          },
        ];

        // Assuming you have new values or variables
        const newRow = row; /* your new value */
        const newRowIndx = rowIndex; /* your new value */
        const newInitData = initData; /* your new value */
        const newFinalResult = finalResult; /* your new value */

        // Update the state with the new values
        setRow(newRow);
        setRowIndex(newRowIndx);
        setListInspection(newInitData);
        setColumnsInspection(newFinalResult);

        setShowScan(false);

        setCreate(true);
        setShow(true);
      } else {
        // await setShowVehicle(true);
        console.log(response.payload.data.error, "response");

        if (response.payload.data.error === "16001") {
          showVehicleDialog(response.payload.data.message).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              setShowScan(false);
              setShowVehicle(true);
            } else if (result.isDenied) {
              setShowScan(false);
            }
          });
        } else {
          showErrorDialog(response.payload.data.message);
        }
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // upload file
  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [rowUpload, setRowUpload] = useState(null);
  const [showUploadView, setShowUploadView] = useState(false);

  const [showUpload, setShowUpload] = useState(false);

  const handleCloseUpload = () => {
    setShowUpload(false);
    setFile(null);
    setFileName("Upload Template File");
  };
  const handleCloseUploadView = () => {
    setShowUploadView(false);
    setRowUpload(null);
  };

  const handleUpload = async () => {
    // if (file) {
    //   return showErrorDialog("Please Input");
    // }
    const params = {
      id: id,
      file: file,
    };
    try {
      const response = await dispatch(addUploadFileRCI(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleCloseUpload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProses = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUpload(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProsesCancel = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUploadCancel(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDownload = async () => {
    const params = {
      id: id,
      type: "RCI",
    };
    try {
      const response = await dispatch(fetchFileTemplate(params));
      if (response.payload.status === 200) {
        const response = await dispatch(fetchFileTemplateBlob(params));
        if (response.payload.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "RCI.xlsx";
          link.click();
        }
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  console.log(formValues, "formValues");

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          <div className="d-flex mb-5 mt-5">
            <div className="p-2">
              <Button
                className="my-btn-primary-dark "
                onClick={(e) => setShowScan(true)}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.rci_status === "COMPLETED"
                }
              >
                Input RCI Details
              </Button>
            </div>
            <div className="mr-auto p-2 ">
              <Button
                className="my-btn-primary-dark"
                onClick={(e) => setShowUpload(true)}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.rci_status === "COMPLETED"
                }
              >
                Upload RCI Details
              </Button>
            </div>
            <div className="p-2">
              <Button
                variant="outline-primary"
                onClick={handleConfirm}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.rci_status === "COMPLETED"
                }
              >
                Confirm
              </Button>
            </div>
            <div className="p-2">
              <Button
                variant="primary"
                onClick={handleComplate}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.rci_status === "COMPLETED"
                }
              >
                Complete
              </Button>
            </div>
            <div className="p-2">
              <Button
                variant="primary"
                onClick={(e) => {
                  setGetDataPrint(true);
                  setShowPrint(true);
                }}
              >
                {" "}
                Print Label
              </Button>
            </div>
          </div>
          <>
            <Tabs
              value={value}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              fullWidth
            >
              <Tab label={`Planned Vehicles`} />
              <Tab label={`Unplanned Vehicles`} />
              <Tab label={`Confirmed Vehicles`} />
            </Tabs>
            {/*  Planned Vehicles*/}
            {value === 0 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 1 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 2 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            <hr />
            <div className="mb-3">
              <p className="font-weight-boldest">File Upload Progress</p>
              <Row>
                <Col md={4}>
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={
                      dataId.tableUploadRCIs !== null
                        ? dataId.tableUploadRCIs
                        : []
                    }
                    columns={columnsFile}
                    hover
                  />
                </Col>
              </Row>
            </div>
          </>
        </CardBody>
      </Card>

      <>
        {/* Modal Inspection */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              {row === null ? "Input" : "Update"} RCI Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="VIN"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="vin"
                    value={formValues.vin.value}
                    onChange={handleChange}
                    error={formValues.vin.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled
                  />

                  <RedditTextField
                    label="VON"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="von"
                    value={formValues.von.value}
                    onChange={handleChange}
                    disabled
                  />
                  <RedditTextField
                    label="Engine No."
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="engine_no"
                    value={formValues.engine_no.value}
                    onChange={handleChange}
                    disabled={
                      formValues.validasi_action.value === "Y" ? true : false
                    }
                  />
                  <RedditTextField
                    label="Mileage"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="number"
                    size="small"
                    fullWidth
                    name="mileage"
                    value={formValues.mileage.value}
                    onChange={handleChange}
                    disabled={
                      formValues.validasi_action.value === "Y" ? true : false
                    }
                  />
                  <RedditTextField
                    required
                    label="Inspection Date"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="datetime-local"
                    size="small"
                    fullWidth
                    name="rci_date"
                    value={formValues.rci_date.value}
                    onChange={handleChange}
                    error={formValues.rci_date.error}
                    helperText={
                      formValues.rci_date.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Key Number"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="key_no"
                    value={formValues.key_no.value}
                    onChange={handleChange}
                    disabled={
                      formValues.validasi_action.value === "Y" ? true : false
                    }
                  />
                  <TextField
                    required
                    id="Inspection Result"
                    select
                    label="Inspection Result"
                    defaultValue="ok"
                    size="small"
                    fullWidth
                    className={classes.margin}
                    onChange={handleInspectionResultChange}
                    value={formValues.inspection_result.value}
                    error={formValues.inspection_result.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled={
                      formValues.validasi_action.value === "Y" ? true : false
                    }
                  >
                    <MenuItem key={1} value={"OK"}>
                      OK
                    </MenuItem>
                    <MenuItem key={1} value={"NG"}>
                      NG
                    </MenuItem>
                  </TextField>
                  <RedditTextField
                    label="Remarks"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="remarks"
                    value={formValues.remarks.value}
                    inputProps={{ maxLength: 150 }}
                    onChange={handleChange}
                    disabled={
                      formValues.validasi_action.value === "Y" ? true : false
                    }
                  />
                  <Form.Check
                    inline
                    label="Require Accessories Installation"
                    name="inbound_rule"
                    type="checkbox"
                    className="ml-5 mb-4 mt-4"
                    onChange={(e) => {
                      if (e.target.checked === true) {
                        setFormValues({
                          ...formValues,
                          ["inbound_rule"]: {
                            ...formValues["inbound_rule"],
                            value: "Y",
                          },
                        });
                      } else {
                        setFormValues({
                          ...formValues,
                          ["inbound_rule"]: {
                            ...formValues["inbound_rule"],
                            value: "N",
                          },
                        });
                      }
                    }}
                    checked={
                      formValues.inbound_rule.value === "Y" ? true : false
                    }
                    disabled={
                      formValues.validasi_action.value === "Y" ? true : false
                    }
                  />
                </Col>
              </Row>
            </ThemeProvider>
            {formValues.inspection_result.value === "NG" && (
              <div>
                <p className="font-weight-boldest">Vehicle Inspection Result</p>
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="name"
                  data={listInspection}
                  columns={columnsInspection}
                  hover
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {formValues.validasi_action.value === "N" && (
              <>
                <Button variant="primary" onClick={(e) => handleSave("save")}>
                  Save
                </Button>
                {formValues.inspection_result.value === "OK" && (
                  <Button variant="primary" onClick={handleSaveConfrim}>
                    Confirm
                  </Button>
                )}
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showDetailDamage}
          onHide={handleCloseDetailDamage}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Input Damage
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Category"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="Category"
                    value={
                      rowInspection === null ? "" : rowInspection.category_name
                    }
                    disabled
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Inspection Point"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="Mileage"
                    value={rowInspection === null ? "" : rowInspection.name}
                    disabled
                  />
                </Col>
              </Row>
            </ThemeProvider>

            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              keyField="no"
              data={detailDamage}
              columns={columnsDetailDamage}
              hover
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            ></BootstrapTable>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDetailDamage}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveDetailDamage}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        {/* scann */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showScan}
          onHide={handleCloseScan}
          onEntered={handleModalEntered}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Scan or Enter Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.Control
                    ref={inputRef}
                    type="text"
                    value={scanFrom}
                    onChange={(e) => setScanFrom(e.target.value)}
                  />
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseScan}>
              Close
            </Button>
            <Button variant="primary" onClick={handleFind}>
              Find
            </Button>
          </Modal.Footer>
        </Modal>

        {/* upload */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUpload}
          onHide={handleCloseUpload}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Upload RCI
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-5">
              <h5 className="font-weight-boldest">File</h5>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.File
                    type="file"
                    id="file_fpre"
                    custom
                    label={fileName}
                    onChange={(e) => {
                      setFile(e.target.files[0]);
                      setFileName(e.target.files[0].name);
                    }}
                    accept=".xlsx, .XLSX"
                  />
                </Col>
                <Col>
                  <Button
                    variant="primary"
                    onClick={handleUpload}
                    className="mr-5 "
                  >
                    Upload
                  </Button>

                  <Button variant="outline-primary" onClick={handleDownload}>
                    Download Template
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseUpload}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* upload View */}
        {rowUpload && (
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showUploadView}
            onHide={handleCloseUploadView}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Upload Vehicle Information Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="d-flex mb-5">
                <div class="p-2 mr-auto font-weight-boldest ">
                  Uploaded Vehicles Data from file "{rowUpload.file_name}"
                </div>
                <div class="p-2 font-weight-boldest">
                  Status :{rowUpload.status}{" "}
                </div>
              </div>
              {rowUpload.status === "Uploaded" && (
                <Row className="ml-2 mb-5">
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleProses}
                  >
                    Process Data
                  </Button>
                  <Button variant="danger" onClick={handleProsesCancel}>
                    Cancel Process Data
                  </Button>
                </Row>
              )}

              <>
                <div
                  className=" "
                  style={{
                    maxHeight: "600px",
                    overflowY: "scroll",
                  }}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={rowUpload !== null ? rowUpload.data : []}
                    columns={columnsUploadRci}
                    hover
                  />
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseUploadView}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>

      {/* Modal Vehicle Create */}
      <VehicleUnplaneCreate
        isOpen={showVehicle}
        setShow={setShowVehicle}
        handleSearch={handleSearch}
        formValues={formVehicle}
        setFormValues={setFormVehicle}
        getData={getData}
        setGetData={setGetData}
        getDataProduct={getDataProduct}
        setGetDataProduct={setGetDataProduct}
        getDataModel={getDataModel}
        setGetDataModel={setGetDataModel}
        getDataColor={getDataColor}
        setGetDataColor={setGetDataColor}
      />

      {/* Modal Vehicle Create */}
      <ModalPrintLabel
        isOpen={showPrint}
        setShow={setShowPrint}
        getData={getDataPrint}
        setGetData={setGetDataPrint}
        id={id}
        labelTemplate={labelTemplate}
        setLabeltemplate={setLabeltemplate}
        vehicle={vehiclePrint}
        setVehicle={setVehiclePrint}
        dataViewer={dataViewer}
        setDataViewer={setDataViewer}
        copy={copy}
        setCopy={setCopy}
        options={optionsList}
        setOptions={setOptionsList}
        page={pagePrint}
        setPage={setPagePrint}
      />
    </>
  );
};
